// build configs ------------------------------------------------------
const SERVICE_URL = process.env.SERVICE_URL || "http://localhost:1337";

export const grapqhURL = `${SERVICE_URL}/graphql`;

export const apiURL = `${SERVICE_URL}/api`;
